export const sizes = {
  padding: {
    sm: "10px 26px",
  },
  height: {
    lg: "50px",
  },
  width: {
    sm: "20%",
    md: "30%",
    lg: "40%",
    full: "100%",
  },
};
export const iconSize = {
  xsm: { width: "15px", height: "15px" },
  sm: { width: "20px", height: "20px", fontSize: "20px" },
  md: { width: "25px", height: "25px", fontSize: "25px" },
  lg: { width: "50px", height: "50px", fontSize: "40px" },
  fit: { width: "100%", height: "100%" },
};
export const linkPadding = {
  none: { padding: "0" },
  sm: { padding: "10px 26px" },
};
export type Size = "xsm" | "sm" | "md" | "lg" | "fit";
export type Padding =  "none" | "sm";
